// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outlined-button {\n  border: 1px solid #DA1B8F;\n  background: #fff !important;\n  color: #DA1B8F !important;\n  font-weight: 600;\n  padding: 10px 40px !important;\n  height: 49px;\n}\n.filled-button {\n  border: 1px solid #DA1B8F;\n  background: #DA1B8F !important;\n  color: #fff !important;\n  font-weight: 600;\n  padding: 10px 40px !important;\n  height: 49px;\n}\n", ""]);
// Exports
module.exports = exports;
